<template>
  <div>
    <v-dialog v-model="dialog" persistent eager scrollable max-width="1000px">
      <v-form ref="PerformanceTarget" @submit.prevent>
        <v-card>
          <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
            <span
              >{{ action }} {{ getMFODesc(target_type) }}
              {{
                data && data.isFaculty == true && data.target_for
                  ? "(" + data.target_for + ")"
                  : ""
              }}</span
            >
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeD()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="my-4">
            <v-container>
              <v-row>
                <!-- <v-col cols="12" v-if="data && data.isFaculty == false"> -->
                <v-col
                  cols="12"
                  v-if="data && data.target_for != 'Instruction'"
                >
                  <div style="border: 1px solid grey" class="rounded-lg">
                    <div class="d-flex justify-space-between align-center pa-4">
                      <div class="text-subtitle-1 mb-1 pa-2">
                        Please select OPCR to link
                      </div>
                      <div>
                        <div
                          cols="6"
                          class="d-flex justify-center align-center"
                        >
                          <v-checkbox
                            v-if="isHeadOrAbove"
                            v-model="isLinkedToMyOPCR"
                            label="OPCR"
                          ></v-checkbox>
                        </div>
                        <div
                          :cols="!isHeadOrAbove ? 6 : 12"
                          :class="
                            !isHeadOrAbove ? 'justify-center align-center' : ''
                          "
                          class="d-flex"
                        >
                          <v-checkbox
                            v-if="!isHeadOrAbove"
                            :class="!isHeadOrAbove ? '' : 'px-2'"
                            v-model="isLinkedToMyHeadOPCR"
                            label="OPCR"
                          ></v-checkbox>
                        </div>
                      </div>
                    </div>
                    <div class="pa-4">
                      <div
                        v-if="
                          isLinkedToMyOPCR &&
                          data &&
                          data.target_for != 'Instruction'
                        "
                      >
                        <v-autocomplete
                          v-model="linked_my_opcr_targetID"
                          dense
                          outlined
                          :rules="isLinkedToMyOPCR ? [formRules.required] : []"
                          class="rounded-lg"
                          item-text="mfo"
                          item-value="id"
                          label="OPCR Target to Link"
                          color="#6DB249"
                          :items="myopcrList"
                        >
                        </v-autocomplete>
                      </div>

                      <div v-if="isLinkedToMyHeadOPCR">
                        <v-autocomplete
                          v-model="linked_head_opcr_targetID"
                          dense
                          :rules="
                            isLinkedToMyHeadOPCR ? [formRules.required] : []
                          "
                          outlined
                          class="rounded-lg"
                          item-text="mfo"
                          item-value="id"
                          label="OPCR Target to Link"
                          color="#6DB249"
                          :items="headopcrList"
                        >
                        </v-autocomplete>
                      </div>
                    </div>
                    <!-- <v-row>
                      <v-col
                        cols="6"
                        class="d-flex justify-center align-center"
                      >
                        <v-checkbox
                          v-if="isHeadOrAbove"
                          v-model="isLinkedToMyOPCR"
                          label="My OPCR"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        :cols="!isHeadOrAbove ? 6 : 12"
                        :class="
                          !isHeadOrAbove ? 'justify-center align-center' : ''
                        "
                        class="d-flex "
                      >
                        <v-checkbox
                          v-if="!isHeadOrAbove"
                          :class="!isHeadOrAbove ? '' : 'px-2'"
                          v-model="isLinkedToMyHeadOPCR"
                          label="OPCR"
                        ></v-checkbox>
                      </v-col>
                    </v-row> -->
                  </div>
                </v-col>
                <!-- <v-col
                  :cols="isLinkedToMyOPCR && isLinkedToMyHeadOPCR ? 6 : 12"
                  v-if="
                    isLinkedToMyOPCR && data && data.target_for != 'Instruction'
                  "
                >
                  <v-autocomplete
                    v-model="linked_my_opcr_targetID"
                    dense
                    outlined
                    :rules="isLinkedToMyOPCR ? [formRules.required] : []"
                    class="rounded-lg"
                    item-text="mfo"
                    item-value="id"
                    label="My OPCR Target to Link"
                    color="#6DB249"
                    :items="myopcrList"
                  >
                  </v-autocomplete>
                </v-col>

                <v-col
                  :cols="isLinkedToMyOPCR && isLinkedToMyHeadOPCR ? 6 : 12"
                  v-if="isLinkedToMyHeadOPCR"
                >
                  <v-autocomplete
                    v-model="linked_head_opcr_targetID"
                    dense
                    :rules="isLinkedToMyHeadOPCR ? [formRules.required] : []"
                    outlined
                    class="rounded-lg"
                    item-text="mfo"
                    item-value="id"
                    label="OPCR Target to Link"
                    color="#6DB249"
                    :items="headopcrList"
                  >
                  </v-autocomplete>
                </v-col> -->

                <v-col v-if="tab == 2 && data && data.isFaculty == true">
                  <v-autocomplete
                    v-model="facultySpSelected"
                    dense
                    :rules="
                      tab == 2 && data && data.isFaculty == true
                        ? [formRules.required]
                        : []
                    "
                    outlined
                    class="rounded-lg"
                    item-text="desc"
                    item-value="id"
                    label="Strategic Priority Selection"
                    color="#6DB249"
                    :items="facultySpSelection"
                    @change="loadIPCRQuality()"
                  >
                  </v-autocomplete>
                </v-col>

                <v-col v-if="tab == 2 && data && data.isFaculty == true">
                  <v-autocomplete
                    v-model="facultySpToSave"
                    dense
                    :rules="
                      tab == 2 && data && data.isFaculty == true
                        ? [formRules.required]
                        : []
                    "
                    outlined
                    class="rounded-lg"
                    item-text="mfo"
                    item-value="id"
                    :label="`${
                      facultySpSelected
                        ? facultySpSelection[facultySpSelected - 1].desc
                        : ''
                    } Strategic Priorities`"
                    color="#6DB249"
                    @change="
                      loadSPToFields();
                      loadIPCRQuality();
                    "
                    :items="
                      facultySpSelected == 1
                        ? facultySpList.research
                        : facultySpList.extensionAndProduction
                    "
                  >
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" class="mt-4">
                  <div
                    class="text-caption blue--text"
                    v-if="
                      data &&
                      data.isFaculty == true &&
                      (tab == 2 || data.target_for == 'Instruction')
                    "
                  >
                    <i
                      >Note : Checkboxes are auto-checked and cannot be
                      changed!</i
                    >
                  </div>
                  <div class="rounded-lg pa-3" style="border: 1px solid gray">
                    <div class="h3 mb-2">
                      <!-- Performance Target
                      Success Indicator (Target + Measure) -->
                      Rating (<i>Uncheck if <b>Not to be Rated</b></i> )
                    </div>
                    <v-row>
                      <v-col
                        cols="4"
                        class="d-flex justify-center align-center"
                      >
                        <v-checkbox
                          :readonly="
                            (data && data.target_for == 'Instruction') ||
                            (tab == 2 && data && data.isFaculty == true)
                          "
                          v-model="eff_is_rated"
                          label="(E) - Efficiency"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="4"
                        class="d-flex justify-center align-center"
                      >
                        <v-checkbox
                          :readonly="
                            (data && data.target_for == 'Instruction') ||
                            (tab == 2 && data && data.isFaculty == true)
                          "
                          v-model="qly_is_rated"
                          label="(Q) - Quality"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="4"
                        class="d-flex justify-center align-center"
                      >
                        <v-checkbox
                          :readonly="
                            (data && data.target_for == 'Instruction') ||
                            (tab == 2 && data && data.isFaculty == true)
                          "
                          v-model="timeliness_is_rated"
                          label="(T) - Timeliness"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    label="Major Final Output"
                    outlined
                    :readonly="tab == 2 && data && data.isFaculty == true"
                    v-model="mfo"
                    dense
                    :rules="[formRules.required]"
                    class="rounded-lg"
                    color="#6DB249"
                  ></v-textarea>
                </v-col>

                <v-col cols="12">
                  <div
                    class="rounded-lg px-3 pb-3"
                    style="border: 1px solid gray"
                  >
                    <div v-if="target_type != 2" class="h3 my-3">
                      Success Indicator (Target + Measure)
                    </div>
                    <div class="d-flex justify-space-evenly mt-8">
                      <div
                        v-if="eff_is_rated && target_type != 3"
                        style="width: 100%"
                      >
                        <div
                          style="border: 1px solid grey"
                          class="rounded-lg pt-1 px-1 ml-1 d-flex justify-space-between items-center"
                        >
                          <div>
                            <div class="text-caption mb-n4">
                              Efficiency Type
                            </div>
                            <v-radio-group
                              @change="setEfficiency()"
                              :rules="
                                target_type != 3 && eff_is_rated
                                  ? [formRules.required]
                                  : []
                              "
                              v-model="efficiency_type"
                              mandatory
                              class="pb-n4"
                              inline
                            >
                              <v-radio
                                label="Numeric"
                                value="numeric"
                              ></v-radio>
                              <v-radio
                                label="Percentage"
                                value="percentage"
                              ></v-radio>
                            </v-radio-group>
                          </div>
                          <div style="width: 50%"></div>
                          <v-text-field
                            v-if="eff_is_rated"
                            label="Efficiency"
                            outlined
                            type="number"
                            :disabled="efficiency_type == 'percentage'"
                            v-model="efficiency"
                            :rules="
                              target_type != 3 && eff_is_rated
                                ? [formRules.required, formRules.numberRequired]
                                : []
                            "
                            dense
                            color="#6DB249"
                            class="mx-1 mt-2"
                          >
                          </v-text-field>
                        </div>
                      </div>
                      <div style="width: 100%" v-if="qly_is_rated">
                        <v-autocomplete
                          v-model="quality"
                          dense
                          :rules="qly_is_rated ? [formRules.required] : []"
                          outlined
                          class="rounded-lg mx-2"
                          item-text="description"
                          item-value="id"
                          label="Quality"
                          color="#6DB249"
                          :items="qlyList"
                        >
                        </v-autocomplete>
                      </div>

                      <div style="width: 100%" v-if="timeliness_is_rated">
                        <v-autocomplete
                          v-model="timeliness_selected"
                          :rules="
                            timeliness_is_rated ? [formRules.required] : []
                          "
                          dense
                          @change="changeTimeliness()"
                          outlined
                          class="rounded-lg mx-2"
                          item-text="description"
                          item-value="id"
                          label="Timeliness Type"
                          color="#6DB249"
                          :items="timelinessList"
                        >
                        </v-autocomplete>
                        <!-- <v-text-field
                          v-if="isToTimelinessNumber"
                          label="Number of day/s, weeks, etc."
                          outlined
                          type="number"
                          v-model="t_num"
                          :rules="
                            isToTimelinessNumber
                              ? [formRules.required, formRules.numberRequired]
                              : []
                          "
                          dense
                          color="#6DB249"
                          class="mx-2 mt-2"
                        >
                        </v-text-field> -->
                        <!-- <div
                          v-if="timeliness_selected"
                          class="ml-2 mb-1 red--text text-caption"
                        >
                          <i>Note: This is not required.</i>
                        </div>
                        <v-text-field
                          v-if="timeliness_selected"
                          label="Timeliness Additional Text"
                          outlined
                          v-model="t_add_desc"
                          dense
                          color="#6DB249"
                          class="mx-1 mx-2"
                        >
                        </v-text-field>

                        <v-textarea
                          v-if="timeliness_selected"
                          label="Timeliness Preview"
                          readonly
                          outlined
                          rows="3"
                          v-model="timelinessPreview"
                          dense
                          color="#6DB249"
                          class="mx-2"
                        >
                        </v-textarea> -->
                      </div>
                    </div>
                    <div class="px-1">
                      <div class="mb-n2 mt-5">
                        <i class="blue--text text-caption"
                          >NOTE: Edit success indicator if needed.</i
                        >
                      </div>
                      <v-textarea
                        label="Success Indicator Preview"
                        outlined
                        :rules="[formRules.required]"
                        rows="3"
                        v-model="success_indicator_preview"
                        dense
                        color="#6DB249"
                        class="mt-4"
                      >
                      </v-textarea>

                      <!-- <v-btn
                        v-if="showResetBtn"
                        small
                        class="white--text"
                        :color="
                          prevSuccessIndicator == null ? '#6DB249' : 'warning'
                        "
                        @click="
                          prevSuccessIndicator == null
                            ? resetSuccessIndicator()
                            : undoSuccessIndicatorReset()
                        "
                        >{{
                          prevSuccessIndicator == null
                            ? "Reset Success Indicator"
                            : "Undo Reset"
                        }}</v-btn
                      > -->
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-5">
            <v-spacer></v-spacer>

            <v-btn color="red" outlined @click="closeD()">
              <v-icon>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>

            <v-btn
              v-if="action == 'Add'"
              color="#519043"
              class="white--text"
              @click="addnew()"
              :disabled="isSubmitLoading"
              :loading="isSubmitLoading"
            >
              <v-icon>mdi-check-circle</v-icon>
              Save
            </v-btn>
            <v-btn
              v-if="action == 'Update'"
              color="#519043"
              class="white--text"
              @click="update()"
              :disabled="isSubmitLoading"
              :loading="isSubmitLoading"
            >
              <v-icon>mdi-check-circle</v-icon>
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
      :timeout="3000"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  props: {
    data: null,
    target_type: null,
    ipcrID: null,
    action: null,
    year: null,
    tab: null,
  },

  data() {
    return {
      id: null,
      timeliness: null,
      timeliness_selected: null,
      success_indicator: null,
      t_num: null,
      t_add_desc: null,
      quality: null,
      efficiency: null,
      efficiency_type: null,
      eff_is_rated: true,
      qly_is_rated: true,
      timeliness_is_rated: true,
      dialog: false,
      qlyList: [],
      timelinessList: [],
      isSubmitLoading: false,
      myopcrList: [],
      headopcrList: [],
      isLinkedToMyOPCR: null,
      isLinkedToMyHeadOPCR: null,
      linked_my_opcr_targetID: null,
      linked_head_opcr_targetID: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      facultySpSelection: [
        { id: 1, desc: "Research" },
        { id: 2, desc: "Extension and Production" },
      ],
      facultySpList: [],
      facultySpSelected: null,
      facultySpToSave: null,
      mfoList: ["Core Functions", "Strategic Priority", "Support Functions"],
      mfo: null,
      mfoDescription: null,
      myOpcrID: null,
      myHeadOpcrID: null,
      prevSuccessIndicator: null,
      showResetBtn: false,
      targetFor: null,
      success_indicator_to_save: null,
      myTaggingType: null,
      is_suc_ind_updated: false,
    };
  },
  watch: {
    data: {
      handler(data) {
        // this.success_indicator_to_save = null;
        this.is_suc_ind_updated = false;
        this.success_indicator_preview = null;
        this.dialog = true;
        this.getMyOPCR();
        this.getDirectHead();
        this.getMyTaggingType();
        console.log("DATA", data);
        if (data.id) {
          this.getFacultySPSelectionForUpdate();
          this.id = data.id;
          this.mfo = data.mfo;
          this.success_indicator = data.success_indicator;
          this.timeliness = data.timeliness;
          this.quality = parseInt(data.quality_util_id);
          this.efficiency = data.efficiency;
          this.efficiency_type = data.efficiency_type;
          this.eff_is_rated = data.eff_is_rated;
          this.qly_is_rated = data.qly_is_rated;
          this.timeliness_is_rated = data.timeliness_is_rated;
          this.t_num = data.t_num;
          this.timeliness_selected = parseInt(data.timeliness_util_id);
          this.t_add_desc = data.t_add_desc;
          this.isLinkedToMyHeadOPCR =
            data.isLinkedToMyHeadOPCR == 1 ? true : false;
          this.isLinkedToMyOPCR = data.isLinkedToMyOPCR == 1 ? true : false;
          if (this.tab == 1) {
            this.linked_head_opcr_targetID = data.linked_head_opcr_targetID
              ? data.linked_head_opcr_targetID.toString()
              : null;
            this.linked_my_opcr_targetID = data.linked_my_opcr_targetID
              ? data.linked_my_opcr_targetID.toString()
              : null;
          } else {
            this.linked_head_opcr_targetID = data.linked_head_pap_taggedID
              ? data.linked_head_pap_taggedID.toString()
              : null;
            this.linked_my_opcr_targetID = data.linked_my_pap_taggedID
              ? data.linked_my_pap_taggedID.toString()
              : null;
          }

          // console.log("dasdad", data);
          this.showResetBtn = data.success_indicator != null;
          this.prevSuccessIndicator = null;
          if (data.isFaculty) {
            let idx = this.facultySpSelection.findIndex(
              (i) => i.desc == data.target_for,
            );

            this.facultySpSelected = idx + 1;
            this.facultySpToSave = data.ipcrFacultyCFSPUtil_ID;
          }
        } else {
          this.getFacultySPSelection();
          this.showResetBtn = false;
          this.id = null;
          this.mfo = null;
          this.timeliness = null;
          this.efficiency_type = null;
          this.quality = null;
          this.efficiency = null;
          this.eff_is_rated = 1;
          this.qly_is_rated = 1;
          this.timeliness_is_rated = 1;
          this.t_num = null;
          this.timeliness_selected = null;
          this.t_add_desc = null;
          if (this.isHeadOrAbove) {
            this.isLinkedToMyOPCR = true;
            this.isLinkedToMyHeadOPCR = false;
          } else {
            this.isLinkedToMyOPCR = false;
            this.isLinkedToMyHeadOPCR = true;
          }

          this.linked_head_opcr_targetID = null;
          this.linked_my_opcr_targetID = null;
          this.prevSuccessIndicator = null;
          this.facultySpSelected = null;
          this.facultySpToSave = null;
        }

        this.getIPCRQuality();
        this.getIPCRTimeliness();
      },

      deep: true,
    },

    success_indicator_to_save: {
      handler(newVal, oldVal) {
        this.is_suc_ind_updated = newVal !== oldVal;
      },
    },

    facultySpSelected: {
      handler(newVal, oldVal) {
        if (oldVal != newVal) {
          this.facultySpToSave = null;
        }
      },
    },
  },
  computed: {
    isHeadOrAbove() {
      return (
        this.$store.state.user.user.user_roleID != 2 &&
        this.$store.state.user.user.user_roleID != 5 &&
        this.$store.state.user.user.user_roleID != 10
      );
    },
    isToTimelinessNumber() {
      let toAdd = false;
      if (this.timeliness_selected) {
        for (let i = 0; i < this.timelinessList.length; i++) {
          if (this.timelinessList[i].id == this.timeliness_selected) {
            toAdd = this.timelinessList[i].toAddNumber;
          }
        }
      }
      return toAdd;
    },

    timelinessPreview() {
      let text = "";
      for (let i = 0; i < this.timelinessList.length; i++) {
        if (this.timelinessList[i].id == this.timeliness_selected) {
          text += this.timelinessList[i].description + " ";
        }
      }
      return text;
    },

    success_indicator_preview: {
      get() {
        let text = "";
        if (this.success_indicator != null) {
          text = this.data.success_indicator;
        } else {
          text = this.mfo ? this.mfo : "";
          if (this.eff_is_rated) {
            if (this.efficiency) text = "100% " + text;
          }
          if (this.qly_is_rated) {
            if (this.quality) text += " " + this.getQualityDesc;
          }
          if (this.timeliness_is_rated) {
            if (this.timeliness_selected) text += " " + this.timelinessPreview;
          }
        }
        return text;
      },
      set(val) {
        this.success_indicator_to_save = val;
      },

      //
    },

    getQualityDesc() {
      let text = "";
      if (this.quality) {
        for (let i = 0; i < this.qlyList.length; i++) {
          if (this.qlyList[i].id == this.quality) {
            text = this.qlyList[i].description;
          }
        }
      }
      return text;
    },
  },

  methods: {
    initialize() {},
    getMFODesc(id) {
      return this.mfoList[id - 1];
    },
    changeTimeliness() {
      this.t_num = null;
      this.t_add_desc = null;
    },
    closeD() {
      this.eventHub.$emit("closeIPCRFunctionDialog", false);
      this.initialize();
      this.isSubmitLoading = false;
      this.dialog = false;
    },

    resetSuccessIndicator() {
      this.prevSuccessIndicator = this.success_indicator;
      this.success_indicator = null;
    },

    undoSuccessIndicatorReset() {
      this.efficiency = this.data.efficiency;
      this.quality = parseInt(this.data.quality_util_id);
      this.timeliness = this.data.timeliness;
      this.timeliness_selected = this.data.timeliness_util_id;
      this.success_indicator = this.prevSuccessIndicator;
      this.prevSuccessIndicator = null;
    },

    loadSPToFields() {
      let data =
        this.facultySpSelected == 1
          ? this.facultySpList.research
          : this.facultySpList.extensionAndProduction;
      let index = data.findIndex((obj) => obj.id === this.facultySpToSave);
      this.eff_is_rated = data[index].eff_is_rated;
      this.qly_is_rated = data[index].qly_is_rated;
      this.timeliness_is_rated = data[index].timeliness_is_rated;
      this.mfo = data[index].mfo;
      this.targetFor = this.facultySpSelection[this.facultySpSelected - 1].desc;
    },

    setEfficiency() {
      if (this.efficiency_type == "percentage") {
        this.efficiency = 100;
      } else {
        this.efficiency = null;
      }
    },

    addnew() {
      if (this.$refs.PerformanceTarget.validate()) {
        this.isSubmitLoading = true;
        let data = {
          ipcr_ID: this.ipcrID,
          target_type: this.target_type,
          mfo: this.mfo,
          efficiency: this.target_type != 3 ? this.efficiency : null,
          efficiency_type: this.target_type != 3 ? this.efficiency_type : null,
          quality_util_id: this.quality,
          quality: this.getQualityDesc,
          // quality: this.quality,
          // timeliness: this.timeliness,
          timeliness: this.timelinessPreview,
          t_num: this.t_num,
          t_add_desc: this.t_add_desc,
          timeliness_util_id: this.timeliness_selected,
          eff_is_rated: this.eff_is_rated,
          qly_is_rated: this.qly_is_rated,
          timeliness_is_rated: this.timeliness_is_rated,
          isLinkedToMyOPCR: this.isLinkedToMyOPCR,
          isLinkedToMyHeadOPCR: this.isLinkedToMyHeadOPCR,
          linked_my_opcr_targetID: this.isLinkedToMyOPCR
            ? this.linked_my_opcr_targetID
            : null,
          linked_head_opcr_targetID: this.isLinkedToMyHeadOPCR
            ? this.linked_head_opcr_targetID
            : null,
          target_for:
            this.tab == 1
              ? this.data.isFaculty
                ? "Designation"
                : null
              : this.targetFor,
          ipcrFacultyCFSPUtil_ID: this.tab == 2 ? this.facultySpToSave : null,
          success_indicator: this.success_indicator_to_save
            ? this.success_indicator_to_save
            : this.success_indicator_preview,
        };
        // console.log(data);
        this.axiosCall("/ipcr-target", "POST", data).then((res) => {
          console.log(res);
          if (res.data.status == 201) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;

            this.closeD();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      }
    },

    update() {
      if (this.$refs.PerformanceTarget.validate()) {
        this.isSubmitLoading = true;
        let data = {
          ipcr_ID: this.ipcrID,
          target_type: this.target_type,
          mfo: this.mfo,
          efficiency: this.target_type != 3 ? this.efficiency : null,
          efficiency_type: this.target_type != 3 ? this.efficiency_type : null,
          // quality: this.quality,
          // timeliness: this.timeliness,
          quality_util_id: this.quality,
          quality: this.getQualityDesc,
          timeliness: this.timelinessPreview,
          t_num: this.t_num,
          t_add_desc: this.t_add_desc,
          timeliness_util_id: this.timeliness_selected,
          eff_is_rated: this.eff_is_rated,
          qly_is_rated: this.qly_is_rated,
          timeliness_is_rated: this.timeliness_is_rated,
          isLinkedToMyOPCR: this.isLinkedToMyOPCR,
          isLinkedToMyHeadOPCR: this.isLinkedToMyHeadOPCR,
          linked_my_opcr_targetID: this.isLinkedToMyOPCR
            ? this.linked_my_opcr_targetID
            : null,
          linked_head_opcr_targetID: this.isLinkedToMyHeadOPCR
            ? this.linked_head_opcr_targetID
            : null,
          success_indicator: this.success_indicator_to_save
            ? this.success_indicator_to_save
            : this.success_indicator_preview,
        };
        console.log(
          "update ",
          data,
          this.is_suc_ind_updated,
          this.success_indicator_to_save,
          this.success_indicator_preview,
        );
        this.axiosCall("/ipcr-target/" + this.id, "PATCH", data).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.closeD();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      }
    },

    getIPCRQuality() {
      console.log("LOAD QLY ", this.data);
      let url = "";

      if (this.data.isFaculty) {
        if (this.data.target_for == "Instruction") {
          if (
            this.data.ipcrFacultyCFSPUtil_ID &&
            (this.data.ipcrFacultyCFSPUtil_ID == 1 ||
              this.data.ipcrFacultyCFSPUtil_ID == 5)
          ) {
            url =
              "/ipcr-quality-util/Instruction/" +
              this.data.ipcrFacultyCFSPUtil_ID;
          } else {
            url = "/ipcr-quality-util";
          }
        } else if (this.data.target_for == "Designation") {
          url = "/ipcr-quality-util";
        } else if (this.data.target_for == "Research") {
          url =
            "/ipcr-quality-util/Research/" + this.data.ipcrFacultyCFSPUtil_ID;
        } else if (this.data.target_for == "Extension and Production") {
          url =
            "/ipcr-quality-util/Extension and Production/" +
            this.data.ipcrFacultyCFSPUtil_ID;
        } else {
          url = "/ipcr-quality-util";
        }
      } else {
        url = "/ipcr-quality-util";
      }

      this.axiosCall(url, "GET").then((res) => {
        this.qlyList = res.data;
      });
    },

    loadIPCRQuality() {
      console.log(
        "LOAD QLY ",
        this.data,
        this.facultySpSelected,
        this.facultySpToSave,
      );
      let url = "";
      if (this.facultySpSelected && this.facultySpToSave) {
        let target_for =
          this.facultySpSelection[this.facultySpSelected - 1].desc;
        url = "/ipcr-quality-util/" + target_for + "/" + this.facultySpToSave;
        this.axiosCall(url, "GET").then((res) => {
          this.qlyList = res.data;
        });
      }
    },

    getIPCRTimeliness() {
      this.axiosCall("/ipcr-timeliness-util", "GET").then((res) => {
        this.timelinessList = res.data;
      });
    },

    getMyOPCR() {
      // let filter = this.$store.getters.getFilterSelected;
      //fetching MyOPCR data for the current year
      this.axiosCall(
        "/opcr-target/getMyOPCR/" + this.year + "/" + this.tab,
        "GET",
      ).then((res) => {
        this.myOpcrID = res.data.opcrID;
        let data = res.data.trgt;
        data.forEach((element, i) => {
          data[i].mfo =
            this.toTitleCase(element.mfo) +
            (element.code ? " (" + element.code + ")" : "");
        });
        this.myopcrList = res.data.trgt;
      });
    },

    getHeadOPCR(id) {
      // let filter = this.$store.getters.getFilterSelected;
      //fetching Head OPCR data for the current year

      this.axiosCall(
        "/opcr-target/getHeadOPCR/" + this.year + "/" + id + "/" + this.tab,
        "GET",
      ).then((res) => {
        console.log("Head", res.data);
        this.myHeadOpcrID = res.data.opcrID;
        this.headopcrList = res.data.trgt;
      });
    },

    getFacultySPSelection() {
      let year = this.data.year;
      this.axiosCall(
        "/ipcr-support-util/getFacultySPSelection?year=" + year,
        "GET",
      ).then((res) => {
        this.facultySpList = res.data;
      });
    },

    getFacultySPSelectionForUpdate() {
      let year = this.data.year;
      this.axiosCall(
        "/ipcr-support-util/getFacultySPSelectionForUpdate?year=" +
          year +
          "&id=" +
          this.data.id,
        "GET",
      ).then((res) => {
        this.facultySpList = res.data;
      });
    },

    getEmpDetails() {
      this.axiosCall("/employee/my-details", "GET").then((res) => {
        console.log(res.data);
        this.assigned_office = res.data.officeID;
      });
    },

    getOffices() {
      this.axiosCall("/offices", "GET").then((res) => {
        this.officeList = res.data;
      });
    },

    getDesignations() {
      this.axiosCall("/designations", "GET").then((res) => {
        this.designationList = res.data;
      });
    },
    getDirectHead() {
      this.axiosCall("/my-direct-head/getMyDirectHead", "GET").then((res) => {
        if (res.data) {
          if (res.data.length > 0) {
            this.getHeadOPCR(res.data[0].userID);
          }
        }
      });
    },
    getMyTaggingType() {
      this.axiosCall("/opcr-target/getMyTaggingType", "GET").then((res) => {
        console.log("Tagging Type", res.data);
        this.myTaggingType = res.data;
      });
    },
  },
};
</script>
